export default "__VITE_ASSET__BIoDZUH7__"